import React from "react";
import Skeleton from "react-loading-skeleton";
import BestSellerCard from "./BestSellerCard";
import type { Product } from "../../utils/api/product/product.type";

export type BestSellerCatalogGridProps = {
  products: Product[];
  isLoading: boolean;
  /** Nombre de cartes squelette (défaut : 4, comme la doc §1.4). */
  skeletonCount?: number;
  /** Passé aux cartes (ex. page Favoris = rendu identique à l’accueil). */
  visualContext?: "default" | "favorisPage";
};

/**
 * Grille produits identique à la section « NOS MEILLEURES VENTES » (doc YEKSINA §1.4).
 * Réutilisable sur la page Favoris pour un rendu strictement identique.
 */
const BestSellerCatalogGrid = ({
  products,
  isLoading,
  skeletonCount = 4,
  visualContext = "default",
}: BestSellerCatalogGridProps) => {
  if (isLoading) {
    return (
      <div className="best-sellers-section-grid" aria-busy="true" role="list">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <div
            key={`bs-grid-skel-${i}`}
            className="best-sellers-section-grid-item"
            role="listitem"
          >
            <div className="best-seller-card best-seller-card--skeleton">
              <Skeleton height={220} className="mb-0" />
              <div className="p-3">
                <Skeleton height={22} className="mb-2" />
                <Skeleton height={18} width="60%" className="mb-3" />
                <Skeleton height={40} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="best-sellers-section-grid" role="list">
      {products.map((item) => (
        <div
          key={item.id}
          className="best-sellers-section-grid-item"
          role="listitem"
        >
          <BestSellerCard item={item} visualContext={visualContext} />
        </div>
      ))}
    </div>
  );
};

export default BestSellerCatalogGrid;
